<template>
  <modal-base @close-modal="$emit('close-modal');slowChangeSocial()">
    <div slot="icon" class="sukima-modal__login__logo__inner">
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
        <path style="fill:white;" d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
      </svg>
    </div>

    <div slot="header" class="sukima-modal__login__error__text">
      {{ headerText }}
      <a @click="description = true" class="d-inline-block">
        <CommentQuestion/>
      </a>
      <transition name="sukima-modal">
        <div class="login-promotion-modal" v-if="description">
          <div>
            <LoginPromotion/>
            <div class="w-100 text-center px-4">
              <a
                  href="#"
                  @click="description = false"
                  class="btn btn-primary rounded-pill btn-block"
                  style="max-width: 400px; margin: auto; margin-bottom: 12px; border-radius: 100px;"
              >
                まずはログインしてみよう！
              </a>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <template slot="body">
      <div v-html="bodyText" v-if="isSocialLogin && !isShowSignUpMerit" class="modal-text"></div>
      <div v-if="beforeLoginProvider" class="modal-text text-danger">
        ※ 前回は{{ beforeLoginProvider }}でログインしています
      </div>
      <!-- 新規会員登録のメリット -->
      <div v-else-if="isShowSignUpMerit" style="font-size: 14px;" class="text-center">
        <div class="pb-2">
          1分で会員登録してチケットを<span class="text-danger font-weight-bold">{{ signupPromotionData.bonusTicket }}</span>枚ゲット！
          <br/><small class="">※ {{ signupPromotionData.bonusTicket }}チケットの有効期限は取得から<span class="text-danger">1週間</span>です。</small>
        </div>
        <div v-html="signupPromotionData.merit"></div>
      </div>

      <div>
        <div class="modal-join" v-if="isSocialLogin">
          <a :href="appsDownloadUrl" class="modal-join__btn font-weight-bold text-primary w-100 font-size-12px ev-app-install" data-provider="" v-if="isVisibleAppDownload"
             @click="evWhenDownload"><span
              class="modal-join__btn__icon--apps"></span>アプリならインストールだけ</a>
          <a :href="'/login/google-oauth2/?next='+next" class="modal-join__btn" @click="evWhenLogin('google')"><span
              class="modal-join__btn__icon--google"></span>Googleでログイン</a>
          <a :href="'/login/line/?next='+next" class="modal-join__btn" @click="evWhenLogin('line')"><span
              class="modal-join__btn__icon--line"></span>LINEでログイン</a>
          <a :href="'/login/twitter/?next='+next" class="modal-join__btn" @click="evWhenLogin('twitter')"><span class="modal-join__btn__icon--twitter"></span>Xでログイン</a>
          <a :href="'/login/yahoojp/?next='+next" class="modal-join__btn" @click="evWhenLogin('yahoojp')"><span class="modal-join__btn__icon--yahoo"></span>Yahoo!
            JAPANでログイン</a>
          <a :href="'/login/facebook/?next='+next" class="modal-join__btn" @click="evWhenLogin('facebook')"><span
              class="modal-join__btn__icon--facebook"></span>Facebookでログイン</a>
          <a :href="'/login/mangazenkan/?next='+next" class="modal-join__btn" @click="evWhenLogin('mangazenkan')"><span
              class="modal-join__btn__icon--mangazenkan"></span>漫画全巻.comでログイン</a>
          <div @click="changeIsSocialLogin(false); evWhenLogin('メール');" class="modal-join__btn">
            <span class="modal-join__btn__icon--mail"></span>メールアドレスでログイン
          </div>
        </div>
        <div class="text-center mt-3">
          <a class="font-weight-bold" :href="'/signup/?next=' + next">新規会員登録はこちら</a>
        </div>
      </div>

      <form id="login-required-form" name="login-required-form" data-toggle="validator" autocomplete="off" :action="loginUrl" method="post" v-if="!isSocialLogin">
        <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken"> <input id="login-required-next" type="hidden" name="next" :value="next"/>
        <!--{{ username }}-->
        <div class="joinForm__items">
          <input id="login-email" class="joinForm__items__inputarea" type="email" onChange="inputNow(this)"
                 name="username" data-error="メールアドレスを入力してください。" required/> <label for="login-email" class="joinForm__items__label">メールアドレス</label>
          <div class="joinForm__items__border"></div>
        </div>
        <div class="joinForm__items">
          <input id="login-password" class="joinForm__items__inputarea" type="password" onChange="inputNow(this)"
                 name="password" maxlength="32" minlength="8" required/> <label for="login-password" class="joinForm__items__label">パスワード(8文字以上)</label>
          <div class="joinForm__items__border"></div>
        </div>
        <a href="/forgot_password/" class="sukima-modal__login__notice" v-if="!isMobileapp">パスワードをお忘れですか？</a>
        <div v-if="!isSocialLogin" class="sukima-modal__login__footer__inner">
          <button class="sukima-modal__login__footer__confirm js-prevent-loading" type="submit" value="ログイン">ログイン</button>
        </div>
      </form>
    </template>

  </modal-base>
</template>

<script>
import ModalBase from './Base';
import CommentQuestion from '../CommentQuestion';
import LoginPromotion from '../LoginPromotion';
import {isIOS, isAndroid} from '../../utils/useragent';
import {getItem} from "../../utils/localstorage";

export default {
  components: {
    ModalBase,
    CommentQuestion,
    LoginPromotion,
  },
  data() {
    return {
      isSocialLogin: true,
      isAppTitle: false,
      description: false,
      beforeLoginProvider: "",
      signupPromotionData: {},
    }
  },
  computed: {
    headerText() {
      return this.isSocialLogin ? "ログインが必要です" : "メールアドレスでログイン"
    },
    location() {
      return window.location;
    },
    isVisibleAppDownload() {
      return (isIOS || isAndroid) && this.isAppTitle;
    },
    appsDownloadUrl() {
      return isIOS ? '/mobileapp/download/ios/' : '/mobileapp/download/android/';
    },
    isShowSignUpMerit() {
      return ['free_for_wait'].includes(this.signupPromotionData.nextStoryType) && !this.beforeLoginProvider
    },
  },
  props: {
    bodyText: String,
    confirmText: String,
  },
  methods: {
    changeIsSocialLogin(value) {
      this.isSocialLogin = value;
    },
    slowChangeSocial() {
      setTimeout(() => {
        this.changeIsSocialLogin(true);
      }, 200);
    },
    evWhenDownload() {
      sendEventDetail({
        category: 'アプリインストール促進',
        action: isIOS ? 'ios' : 'android',
        label: location.pathname,
      });
    },
    evWhenLogin(provider) {
      sendEventDetail({
        category: 'ログイン',
        action: `viewer:${provider}`,
        label: location.pathname,
      });
    },
  },
  created() {
    // django templateの変数を取得する
    try {
      if (document.getElementById('sukima-modal-data')) {
        const dataSet = document.getElementById('sukima-modal-data').dataset;
        this.isAppTitle = dataSet.isapptitle === 'true';
        this.csrfToken = dataSet.csrftoken;
        this.loginUrl = dataSet.loginurl;
        this.next = dataSet.next;
        this.isSmartphone = dataSet.issmartphone;
        this.isMobileapp = dataSet.ismobileapp;
        this.isPremium = dataSet.userpremium;
        this.signupPromotionData = {
          merit: dataSet.signupMerit,
          bonusTicket: dataSet.signupBonusTicket,
          nextStoryType: dataSet.nextStoryType,
        };
        this.beforeLoginProvider = getItem('beforeLoginProvider');
      }
    } catch (e) {
      console.error(e);
    }
  },
};

function inputNow(thisone) {
  var targetLabel = thisone.nextElementSibling;
  if (thisone.value !== '') {
    targetLabel.className = 'joinForm__items__label--focusing';
  } else {
    targetLabel.className = 'joinForm__items__label';
  }
}
</script>
<style lang="scss">
.font-size-12px {
  font-size: 12px;
}

.login-promotion-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000000;
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  padding: 10px;

  > div {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
    background: #ccc;
    margin-bottom: 30px;
    padding-bottom: 10px;
  }
}
</style>
